// Hooks
import { useRef } from "react";
// Email JS
import emailjs from "@emailjs/browser";
// Styled components
import {
  ContactFormWrapper,
  ContactSection,
  ContactSectionHeading,
  Form,
  Input,
  InputSubmit,
  Label,
  TextArea,
} from "./Contact.style";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_4le96su",
        "template_o0vfwvs",
        form.current,
        "gf1ZxP3YQNYqUcO6g"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  return (
    <ContactSection id="contact">
      <ContactSectionHeading>Contact</ContactSectionHeading>
      <ContactFormWrapper>
        <Form ref={form} onSubmit={sendEmail}>
          <Label>Nome:</Label>
          <Input
            type="text"
            name="user_name"
            placeholder="Digite seu nome..."
            required
          />
          <Label>E-mail:</Label>
          <Input
            type="email"
            name="user_email"
            placeholder="Digite seu e-mail..."
            required
          />
          <Label>Mensagem:</Label>
          <TextArea
            name="message"
            placeholder="Digite uma mensagem..."
            required
          />
          <InputSubmit type="submit" value="Enviar" />
        </Form>
      </ContactFormWrapper>
    </ContactSection>
  );
};

export default Contact;
